module.exports = __webpack_public_path__ + "static/media/faq-arrow1.d4dc6703.svg";